import React from 'react'
import "./experionce.scss"
const Experience = () => {
    return (
        <>
            <section className='experiencemain'>
                <div className="custom-container">
                    <div className="experienceprntmain">
                        <h2>Experience the future of crypto—powered by AI.</h2>
                        
                            <div className="walletbannerbtn">

                                <a className="herofeaturebannerbtn primerybtn" href="https://play.google.com/store/apps/details?id=com.tomiapp.production&hl=en" target="_blank">
                                    <img src="\assets\Wallet\playstorebtnbanner.svg" alt="playstoreimg" />
                                </a>
                                <a className="herofeaturebannerbtn primerybtn" href="https://apps.apple.com/us/app/tomi-ai-crypto-wallet/id1643501440" target="_blank">
                                    <img src="\assets\Wallet\Appstorebtnbanner.svg" alt="Appstoreimg" />
                                </a>
                            </div>
                        
                    </div>
                </div>
            </section>

        </>
    )
}

export default Experience